import { useEffect, useState } from "react";
import MainCartDialog, { IMainCartDialogProps } from "./mainCartDialog";
import { ICartItem } from "../../../../../../../../Interfaces/componentTypes";
import OrderDeliveryDialog from "../OrderDeliveryDialog/orderDeliveryDialog";
import PreOrderDialog from "../PreOrder/preOrderDialog";
import { getTotalCartItemCount } from "../../../../../../../../Utilits/utilits";

const useMainCartDialog = (props: IMainCartDialogProps) => {
    const { companyId, company_logo, company_name, company_contacts, cart, setMainCart, serviceFee, services, setDialog, onCloseDialog, currencySymbol, deliveryMinCost, deliveryCities, setContentType, start_time, end_time } = props;
    const [dialogCart, setDialogCart] = useState<[] | ICartItem[]>(cart);

    useEffect(() => {
        setDialogCart(cart);
    }, [cart]);

    const calculateTotalPrice = (cart: ICartItem[]) => {
        let total = 0;
        for (const item of cart) {
            let itemTotal = 0;
            for (const option of item.option) {
                itemTotal += parseFloat(option.price) * option.count;
            }
            total += itemTotal;
        }
        if (typeof serviceFee === 'number') {
            let dinInCost = total;
            dinInCost += dinInCost * (serviceFee / 100);
            setDineInPrice(dinInCost);
        } else {
            setDineInPrice(total);
        }
        setTotalPrice(total);
    };

    const [totalPrice, setTotalPrice] = useState<number>(0);
    const [dineInPrice, setDineInPrice] = useState<number>(0);
    const [packageFee, setPackageFee] = useState<number>(0);
    const [showEmptyCart, setShowEmptyCart] = useState(false);
    const isAnyActiveService = services?.delivery?.is_active || services?.pre_order || services?.reserve;
    const totalItemCount = getTotalCartItemCount(dialogCart);

    const calculatePackageFee = (cart: ICartItem[]) => {
        let total = 0;
        for (const item of cart) {
            let itemTotal = 0;
            for (const option of item.option) {
                if (option.package_cost) {
                    itemTotal += parseFloat(option.package_cost) * option.count;
                }
            }
            total += itemTotal;
        }
        setPackageFee(total);
    };

    const removeFromDialogCart = (itemId: number) => {
        setDialogCart((prevCart) => {
            const updatedCart = prevCart.filter((cartItem) => cartItem.id !== itemId);
            setMainCart(updatedCart);
            return updatedCart;
        });
    };

    const onOpenMainCartDialog = () => {
        setDialog(
            <MainCartDialog
                companyId={companyId}
                company_name={company_name}
                company_logo={company_logo}
                cart={dialogCart}
                setMainCart={setMainCart}
                currencySymbol={currencySymbol}
                serviceFee={serviceFee}
                services={services}
                setDialog={setDialog}
                onCloseDialog={onCloseDialog}
                deliveryMinCost={deliveryMinCost}
                setContentType={setContentType}
                start_time={start_time}
                end_time={end_time}
            />
        );
    };

    const onOpenOrderDeliveryDialog = () => {
        setDialog(
            <OrderDeliveryDialog
                companyId={companyId}
                company_name={company_name}
                company_logo={company_logo}
                company_contacts={company_contacts}
                cart={dialogCart}
                currencySymbol={currencySymbol}
                totalPrice={totalPrice}
                packageFee={packageFee}
                deliveryMinCost={deliveryMinCost!}
                deliveryCities={deliveryCities}
                onOpenMainCartDialog={onOpenMainCartDialog}
                setDialog={setDialog}
                setMainCart={setMainCart}
                onCloseDialog={onCloseDialog}
                totalItemCount={totalItemCount}
                setContentType={setContentType}
                start_time={start_time}
                end_time={end_time}
            />
        );
    };

    const onOpenPreOrderDialog = () => {
        setDialog(
            <PreOrderDialog
                companyId={companyId}
                company_name={company_name}
                company_logo={company_logo}
                company_contacts={company_contacts}
                cart={dialogCart}
                currencySymbol={currencySymbol}
                totalPrice={totalPrice}
                packageFee={packageFee}
                onOpenMainCartDialog={onOpenMainCartDialog}
                setDialog={setDialog}
                setMainCart={setMainCart}
                onCloseDialog={onCloseDialog}
                totalItemCount={totalItemCount}
                setContentType={setContentType}
                start_time={start_time}
                end_time={end_time}
            />
        );
    };

    useEffect(() => {
        setMainCart(dialogCart);
        calculateTotalPrice(dialogCart);
        (services?.delivery?.is_active || services?.pre_order) && calculatePackageFee(dialogCart);
        setShowEmptyCart(dialogCart.length === 0);
    }, [dialogCart]);

    return {
        totalPrice,
        packageFee,
        dialogCart,
        dineInPrice,
        showEmptyCart,
        isAnyActiveService,
        setDialogCart,
        onOpenPreOrderDialog,
        removeFromDialogCart,
        onOpenOrderDeliveryDialog,
    };
};

export default useMainCartDialog;
